/**
 * @author       Lordd Michael Lazaro <lorddlazaro.taktyl@gmail.com>
 */



/**
 * [description]
 *
 * @function generateUniqueRandomNumberArray
 *
 * @param {integer} length Array Length
 * @param {integer} rangeStart Range start inclusive
 * @param {integer} rangeEnd Range end exclusive
 *
 * @return {Array<integer>} [description]
 */
export var GenerateUniqueRandomIntegerArray = function(length:number,rangeStart:number,rangeEnd:number):number[]{
    let uniqueRandomArray = [];
    let actualLength = rangeEnd - rangeStart < length ? rangeStart - rangeEnd : length;
    while(uniqueRandomArray.length < actualLength){
        //console.log('generateLetterChoices:GenerateUniqueRandomIntegerArray!');
        let randomNum = Math.floor(Math.random()*(rangeEnd-rangeStart)) + rangeStart; 
        if(uniqueRandomArray.indexOf(<never>randomNum) > -1) continue;
        uniqueRandomArray[uniqueRandomArray.length] = <never>randomNum;
    }
    return uniqueRandomArray;
};
